function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.38889 26.125H2.51389V26V2.38889C2.51389 1.93632 2.14701 1.56944 1.69444 1.56944C1.24188 1.56944 0.875 1.93632 0.875 2.38889V26V26.125H1H2.38889Z",
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.3611 26.125H18.4861V26V2.38889C18.4861 1.93632 18.1192 1.56944 17.6666 1.56944C17.214 1.56944 16.8472 1.93632 16.8472 2.38889V26V26.125H16.9722H18.3611Z",
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 0.875,
  y: 24.4861,
  width: 17.6111,
  height: 1.63889,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 2.95801,
  y: 5.73611,
  width: 13.4444,
  height: 12.75,
  rx: 2.125,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 5.73633,
  y: 0.875,
  width: 0.944444,
  height: 5.11111,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6807,
  y: 0.875,
  width: 0.944444,
  height: 5.11111,
  fill: "#4285F4",
  stroke: "white",
  strokeWidth: 0.25
});

function SvgDoMoCong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 27,
    viewBox: "0 0 19 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoMoCong);
export default __webpack_public_path__ + "static/media/DoMoCong.ad1ca734.svg";
export { ForwardRef as ReactComponent };